import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import 'moment/locale/en-gb';
import 'moment/locale/de';
import 'moment/locale/fr';
import 'moment/locale/ko';
import 'moment/locale/zh-cn';

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        supportedLngs: ['en', 'de', 'fr', 'ko', 'zh'],
        detection: {
            order: ['sessionStorage'],
            lookupSessionStorage: 'lng',
            caches: ['sessionStorage']
        },
        backend: {
            loadPath: `${process.env.PUBLIC_URL || ''}/locales/{{lng}}/translation.json`
        },
        interpolation: {
            escapeValue: false
        },
        debug: false
    });

export default i18n;
